import { basename as infrastructureBasename } from '@guildeducationinc/frontend-infrastructure';
import { GUILD_URL } from '@src/constants';

export const basename = infrastructureBasename({ path: '/home' });

export interface EmployerUrlParameters {
  employerNickname?: string;
  destinationPath?: string;
}

/**
 * Constructs the base employer url `https://<subdomain>.<domain>.com`. Defaults subdomain is 'students' if none is provided.
 * Attempts to use the GUILD_URL environment variable if it is provided so that local development
 * behavior can be overridden if desired.
 *
 * ```ts
 * employerUrl({})
 * employerUrl({ employerNickname: 'chipotle' })
 * employerUrl({ employerNickname: 'chipotle', destinationPath: '/users/edit' })
 * ```
 * @packageDocumentation
 */
export const employerUrl = ({
  employerNickname,
  destinationPath = '',
}: EmployerUrlParameters): string => {
  const subdomain = employerNickname || 'students';
  const baseUrl = GUILD_URL.replace('students', subdomain);

  return `${baseUrl}${destinationPath}`;
};
